/**
 * Extension ´BwCaptcha´
 * JavaScript-Funktionalitäten bzgl. Neuladen des Captcha-bildes und Audio anhören.
 * Inline-Handling von der Extension wurde aufgrund von CSP per Template entfernt.
 */

import {getUid} from '../../Shared/utils';

import SelectorEngine from '../../Shared/dom/selector-engine';

const setupCaptcha = (container) => {
	const image = SelectorEngine.findOne('.bw-captcha-media img', container) ?? null;
	const ctrlReload = SelectorEngine.findOne('button.bw-captcha-reload', container) ?? null;
	const ctrlReloadUrl = ctrlReload ? ctrlReload.dataset.url : '';
	const ctrlAudio = SelectorEngine.findOne('button.bw-captcha-audio', container) ?? null;
	const ctrlAudioUrl = ctrlAudio ? ctrlAudio.dataset.url : '';

	if (!image) {
		container.classList.add('-disable');

		return;
	}

	if (ctrlReload && ctrlReloadUrl) {
		image.addEventListener('load', (event) => {
			ctrlReload.setAttribute('aria-pressed', 'false');

			container.setAttribute('aria-busy', 'false');
			container.classList.remove('-reloading');
		});

		ctrlReload.addEventListener('click', (event) => {
			event.preventDefault();
			event.stopPropagation();

			event.target.setAttribute('aria-pressed', 'true');

			container.setAttribute('aria-busy', 'true');
			container.classList.add('-reloading');

			image.setAttribute('src', ctrlReloadUrl + (/\?/.test(ctrlReloadUrl) ? '&' : '?') + 'now=' + Date.now());
		});
	} else if (ctrlReload) {
		ctrlReload.dataset.captchaError = 'Attribut ´data-url´ for captcha reload failed';
		ctrlReload.disabled = true;
	}

	if (ctrlAudio && ctrlAudioUrl) {
		window.captchaAudio = window.captchaAudio ?? new Audio();

		window.captchaAudio.addEventListener('ended', () => {
			ctrlAudio.setAttribute('aria-pressed', 'false');

			container.classList.remove('-playing');
		});

		ctrlAudio.addEventListener('click', (event) => {
			const audioPressed = event.target.getAttribute('aria-pressed');

			event.preventDefault();
			event.stopPropagation();

			container.classList.add('-playing');

			if (!audioPressed || audioPressed !== 'true') {
				const c = document.createElement('canvas');
				const ctx = c.getContext('2d');
				const data = new FormData();

				c.width = image.naturalWidth;
				c.height = image.naturalHeight;

				ctx.drawImage(image, 0, 0);

				data.append('captchaDataUrl', c.toDataURL());

				fetch(ctrlAudioUrl, {
					method: 'POST',
					body: data
				})
					.then(response => response.blob())
					.then(blob => {
						container.classList.add('-playing');

						window.captchaAudio.src = window.URL.createObjectURL(blob);
						window.captchaAudio.play();
					});
			}
		});
	} else if (ctrlAudio) {
		ctrlAudio.dataset.captchaError = 'Attribut ´data-url´ for captcha audio failed';
		ctrlAudio.disabled = true;
	}
};

document.addEventListener('DOMContentLoaded', function () {
	const collection = SelectorEngine.find('[data-provider="bw-captcha"]');

	for (const element of collection) {
		setupCaptcha(element);
	}
});
